import { Box, Button, Container, Divider, Grid, Typography } from '@material-ui/core';
import { CloudResultCardDetails } from '../../transaction-handling/cloud-transaction';
import { useTransactionDetailPageStyle } from '../TransactionPage/TransactionDetailsPage/TransactionDetailsPage.style';
import { formatMaskedCardNumber, formatTitleCase } from '../../utils/common/helpers';

interface Props {
  resultCardDetails?: CloudResultCardDetails;
}

export function CloudPaymentDetails({ resultCardDetails }: Props) {
  const classes = useTransactionDetailPageStyle();

  return (
    <>
      <Typography className={classes.heading}>Payment Details</Typography>
      <div className={classes.orderInfo}>
        <Typography className={classes.body}>Entry mode:</Typography>
        <Box bgcolor="rgba(234, 236, 240, 1)" paddingX={1} width="max-content" borderRadius={4} overflow="auto">
          <Typography variant="body2" component="code">
            {formatTitleCase(resultCardDetails?.entry_mode)}
          </Typography>
        </Box>
        <Typography className={classes.body}>Scheme:</Typography>
        <Box bgcolor="rgba(234, 236, 240, 1)" paddingX={1} width="max-content" borderRadius={4} overflow="auto">
          <Typography variant="body2" component="code">
            {formatTitleCase(resultCardDetails?.scheme_name)}
          </Typography>
        </Box>
        <Typography className={classes.body}>Card number:</Typography>
        <Box bgcolor="rgba(234, 236, 240, 1)" paddingX={1} width="max-content" borderRadius={4} overflow="auto">
          <Typography variant="body2" component="code">
            {formatMaskedCardNumber(resultCardDetails?.pan_first_6, resultCardDetails?.pan_last_4) ?? 'N/A'}
          </Typography>
        </Box>
      </div>
    </>
  );
}
